import { isNullOrUndefined, onReady } from "/Assets/js/common/utilities.js";

export default class ButtonBlock {
    init() {
        onReady(() => {
            let pcodeElement = document.querySelector("[data-product-code]");
            if (!pcodeElement)
                return;

            let pcode = pcodeElement.getAttribute("data-product-code");
            if (isNullOrUndefined(pcode))
                return;

            let elems = document.querySelectorAll(".how-can-we-help a[href*='resources/resources-by-product'], .btn-cntnr > a[href*='resources/resources-by-product'], .sticky-nav-cta a[href*='resources/resources-by-product']");
            if (!elems.length)
                return;

            elems.forEach(item => {
                let currentUrl = new URL(window.location.href);
                let href = item.getAttribute("href");
                var destinationUrl = new URL(currentUrl.protocol + "//" + currentUrl.host + href);

                if (destinationUrl.searchParams.has("productcode")) {
                    destinationUrl.searchParams.set("productcode", pcode);
                } else {
                    destinationUrl.searchParams.append("productcode", pcode);
                }
                item.setAttribute("href", destinationUrl);
            });
        });
    }
}
